<div class="flex flex-col min-h-screen" style="margin-top: 1rem; padding: 0 1rem">
  <div class="flex items-center justify-center">
    <p-fluid>
      <div class="flex items-center justify-center w-full">
        <div class="w-full max-w-xl rounded-xl">
          <div class="card flex flex-col gap-4 mt-3">
            <div data-testid="registration-title" class="font-semibold text-2xl">
              {{ 'account.register.createAccount' | transloco }}
            </div>
            <div data-testid="registration-description">
              {{ 'account.register.completeRegistration' | transloco }}
            </div>

            @if (loading) {
              <div class="flex justify-center">
                <i
                  data-testid="loading-spinner"
                  class="pi pi-spin pi-spinner"
                  style="font-size: 2rem"
                ></i>
              </div>
            }

            @if (error && !loading) {
              <div data-testid="error-message" class="text-red-500">
                {{ 'common.invalidToken' | transloco }}
              </div>
            }

            @if (!error && !loading) {
              <form
                data-testid="registration-form"
                [formGroup]="form"
                (ngSubmit)="onSubmit()"
                class="flex flex-col gap-4"
              >
                <app-form-field
                  id="email"
                  fieldName="email"
                  label="common.email"
                  type="email"
                  disabled="true"
                ></app-form-field>

                <app-form-field
                  id="companyName"
                  fieldName="companyName"
                  label="common.companyName"
                  disabled="true"
                ></app-form-field>

                <app-form-field
                  id="password"
                  fieldName="password"
                  label="common.password"
                  type="password"
                ></app-form-field>

                <app-form-field
                  id="passwordRepeat"
                  fieldName="passwordRepeat"
                  label="account.register.passwordRepeat"
                  type="passwordRepeat"
                ></app-form-field>

                @if (newsletterEnabled) {
                  <div class="flex items-start gap-2">
                    <p-checkbox
                      formControlName="newsletterSubscribed"
                      [binary]="true"
                      inputId="newsletterSubscribed"
                      data-testid="newsletter-checkbox"
                    ></p-checkbox>
                    <label for="newsletterSubscribed" class="text-sm">
                      {{ 'account.register.newsletterOptIn' | transloco }}
                    </label>
                  </div>
                }

                <div class="mt-4">
                  <p-button
                    data-testid="register-button"
                    type="submit"
                    [label]="'account.register.registerProjectUser' | transloco"
                    [loading]="submitting"
                    [disabled]="form.invalid"
                  ></p-button>
                </div>
              </form>
            }
            @if (!loading) {
              <div class="text-center mt-4">
                <span data-testid="already-have-account-text">{{
                  'account.register.alreadyHaveAccount' | transloco
                }}</span>
                <button
                  data-testid="sign-in-link"
                  type="button"
                  class="ml-2 text-blue-600 underline cursor-pointer bg-transparent border-none p-0"
                  (click)="goToLogin()"
                >
                  {{ 'common.signIn' | transloco }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </p-fluid>
  </div>
</div>
